/* eslint-disable no-underscore-dangle */

if (typeof window !== 'undefined' && window.__webpack_public_path__) {
  // @ts-expect-error __webpack_public_path__ exists on webpack
  __webpack_public_path__ = window.__webpack_public_path__;
}

// We must treat this file as an export because isolateModules is set
export {};
/* eslint-enable no-underscore-dangle */
